import {
    page_update_native_ad,
    page_update_sections,
} from "../../reducers/Page/reducer";
import { updatePageSections, filterNativeAds } from "./utils";

/**
 * Async action creator to update page content in a FLP page load more sections
 * @param {Object} loadMore - loadMore section data: newSize, disableLoadMore, newContent
 * @param {Object} metadata - sectionIndex, contentIndex, position
 */
export const update_page_sections = (loadMore, metadata) => {
    return (dispatch, getState) => {
        const sections = updatePageSections(
            getState().page.sections,
            loadMore,
            metadata
        );
        dispatch(page_update_sections({ sections }));
    };
};

/**
 * Async action creator to update native ad on a FLP page
 * @param {object} payload the page payload data
 */
export const update_page_native_ad = (hasNativeAd) => {
    return (dispatch, getState) => {
        const sections = getState().page.sections
            ? filterNativeAds([...getState().page.sections])
            : [];
        dispatch(page_update_native_ad({ sections, hasNativeAd }));
    };
};
